module.exports = __webpack_public_path__ + "7a1d71479739fe4b5b259e8641b92bfc.svg";